import { create } from 'zustand';
import { api } from '@/lib/api';

interface TaxState {
  selectedYear: number;
  taxSummary: any | null;
  documents: any[];
  businesses: any[];
  investments: any[];
  deductions: any[];
  isLoading: boolean;
  error: string | null;

  setSelectedYear: (year: number) => void;
  fetchTaxSummary: (year: number) => Promise<void>;
  fetchDocuments: (year?: number) => Promise<void>;
  fetchBusinesses: (year?: number) => Promise<void>;
  fetchInvestments: (year: number) => Promise<void>;
  fetchDeductions: (year: number) => Promise<void>;
  clearError: () => void;
}

export const useTaxStore = create<TaxState>((set, get) => ({
  selectedYear: new Date().getFullYear(),
  taxSummary: null,
  documents: [],
  businesses: [],
  investments: [],
  deductions: [],
  isLoading: false,
  error: null,

  setSelectedYear: (year: number) => {
    set({ selectedYear: year });
  },

  fetchTaxSummary: async (year: number) => {
    set({ isLoading: true, error: null });
    try {
      const summary = await api.getTaxSummary(year);
      set({ taxSummary: summary, isLoading: false });
    } catch (err) {
      set({ isLoading: false, error: (err as Error).message });
    }
  },

  fetchDocuments: async (year?: number) => {
    set({ isLoading: true, error: null });
    try {
      const response = await api.listDocuments({ year });
      set({ documents: response.documents, isLoading: false });
    } catch (err) {
      set({ isLoading: false, error: (err as Error).message });
    }
  },

  fetchBusinesses: async (year?: number) => {
    set({ isLoading: true, error: null });
    try {
      const response = await api.listBusinesses({ year });
      set({ businesses: response.businesses, isLoading: false });
    } catch (err) {
      set({ isLoading: false, error: (err as Error).message });
    }
  },

  fetchInvestments: async (year: number) => {
    set({ isLoading: true, error: null });
    try {
      const response = await api.listInvestments({ year });
      set({ investments: response.investments, isLoading: false });
    } catch (err) {
      set({ isLoading: false, error: (err as Error).message });
    }
  },

  fetchDeductions: async (year: number) => {
    set({ isLoading: true, error: null });
    try {
      const response = await api.getDeductions(year);
      set({ deductions: response.deductions, isLoading: false });
    } catch (err) {
      set({ isLoading: false, error: (err as Error).message });
    }
  },

  clearError: () => set({ error: null }),
}));
